// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".latest-search li button{line-height:2}.latest-search li button>span{text-shadow:1px 0 0 #007bff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
